import { Injectable } from '@angular/core';
import { HTMLTable} from '../../../model/html/html-elements/html-table';
import { InterfaceElement, IEFilter, IEUserAction } from '../../../model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { ColItem, HeaderItem, RowItem } from '../../../model/asd/asd-properties/asd-ie-type/asd-list';
import { InterfaceElementTypes } from '../../../model/interfaceElement/interfaceElement-properties/interfaceElement-type';
import { InterfaceElementDataTypes } from '../../../model/interfaceElement/interfaceElement-properties/interfaceElement-datatype';
import { ViewArea } from '../../../model/asd/asd-properties/asd-viewArea';
import { Header } from '../../../model/asd/asd-properties/asd-header';

import { CosyCommunicationControllerService } from '../../controller/cosy-communication-controller.service';

import 'globalize/number';
import 'globalize/plural';
import { LocaleTypes } from 'src/app/model/locale/locale-type';
import { Attribute } from 'src/app/model/asd/asd-properties/asd-attribute';
import moment from 'moment';

const numberingSystems = require('cldr-data/supplemental/numberingSystems.json');
const plurals = require('cldr-data/supplemental/plurals.json');
const likelySubtags = require('cldr-data/supplemental/likelySubtags.json');
// locale files
const deCldrNumbersData = require('cldr-data/main/de/numbers.json');
const enCldrNumbersData = require('cldr-data/main/en/numbers.json');
const zhCldrNumbersData = require('cldr-data/main/zh/numbers.json');
// globalize itself
const Globalize = require('globalize');

Globalize.load(
  numberingSystems,
  plurals,
  likelySubtags,
  deCldrNumbersData,
  enCldrNumbersData,
  zhCldrNumbersData,
);


@Injectable()
export class CosyHtmlElementGenerationService {
  constructor(
    private cosyCommunicationControllerService: CosyCommunicationControllerService
  ) {}

  private oldTermCalled: string = '';
  private newTermCalled: string = '';
  private oldTermOrder: string = '';
  private newTermOrder: string = '';

  parsed: number;
  

  generateSortableRowsOfHTMLTable(term: any, dataTypeID: string, order: string, ieListGridView: HTMLTable) {
    let rIndex: number = -1;
    let doSort: boolean = false;
    
    this.newTermCalled = term;
    this.newTermOrder = order;

    if (this.oldTermCalled !== this.newTermCalled && this.oldTermOrder !== this.newTermOrder) {
      this.oldTermOrder = term;
      this.oldTermOrder = order;
      doSort = true;
    }

    if (ieListGridView != null && ieListGridView.rowItems != null && ieListGridView.rowItems.length > 0) {
      rIndex = ieListGridView.rowItems[0].ColItems.map(function(d) {
        return d['Name'];
      }).indexOf(term);
      if (rIndex > -1) {
        if (dataTypeID == InterfaceElementDataTypes.IntegerDT) {
          order == 'desc'
            ? ieListGridView.rowItems.sort((n1, n2) => n2.ColItems[rIndex].Value - n1.ColItems[rIndex].Value)
            : ieListGridView.rowItems.sort((n1, n2) => n1.ColItems[rIndex].Value - n2.ColItems[rIndex].Value);
        } else if (dataTypeID == InterfaceElementDataTypes.StringDT) {
          order == 'desc'
            ? ieListGridView.rowItems.sort((a, b) => 0 - (a.ColItems[rIndex].Value >= b.ColItems[rIndex].Value ? 1 : -1))
            : ieListGridView.rowItems.sort((a, b) => 0 - (b.ColItems[rIndex].Value >= a.ColItems[rIndex].Value ? 1 : -1));
        } else if (dataTypeID == InterfaceElementDataTypes.DateDT) {
          order == 'desc'
            ? ieListGridView.rowItems.sort((a, b) => new Date(a.ColItems[rIndex].Value).getTime() - new Date(b.ColItems[rIndex].Value).getTime())
            : ieListGridView.rowItems.sort((a, b) => new Date(b.ColItems[rIndex].Value).getTime() - new Date(a.ColItems[rIndex].Value).getTime());
        }
      } 
    }
    
    return ieListGridView;
  }

  modifyPerHeaderDataType(colItem: ColItem, headerDT: string){

    if(headerDT == InterfaceElementDataTypes.DoubleDT){
      
      if(this.cosyCommunicationControllerService.locale == LocaleTypes.LocaleTypeDE_CODE){
        Globalize.locale('de');
        const thousandSeparator = Globalize.cldr.main("numbers/symbols-numberSystem-latn/group");
        const replaced = colItem.Value.replace(new RegExp(`\\${thousandSeparator}`, 'g'), '');
        this.parsed = Globalize.parseNumber(replaced);
        colItem.Value = (this.parsed).toLocaleString(this.cosyCommunicationControllerService.locale, {minimumFractionDigits: 2});
      }

      if(this.cosyCommunicationControllerService.locale == LocaleTypes.LocaleTypeEN_CODE){
        colItem.Value = (parseFloat(colItem.Value)).toLocaleString(this.cosyCommunicationControllerService.locale, {minimumFractionDigits: 2});
      }
    }
    return colItem;
  }

  updateDisplayOnLocale(ie: InterfaceElement){

    if(ie.CosyDataTypeID == InterfaceElementDataTypes.DoubleDT 
      || ie.CosyDataTypeID  == InterfaceElementDataTypes.DecimalDT
      || ie.CosyDataTypeID  == InterfaceElementDataTypes.FloatDT
      || ie.CosyDataTypeID == InterfaceElementDataTypes.IntegerDT
      || ie.CosyDataTypeID == InterfaceElementDataTypes.LongDT
      || ie.CosyDataTypeID  == InterfaceElementDataTypes.ShortDT){
      
        if(ie.Values.length>0){
          let result = ie.Values[0].Value;
          if(ie.Attributes.DisplayFormat == null){
              if(this.cosyCommunicationControllerService.locale == LocaleTypes.LocaleTypeDE_CODE){
                if(this.cosyCommunicationControllerService.locale == LocaleTypes.LocaleTypeDE_CODE){
                  result = new Intl.NumberFormat(LocaleTypes.LocaleTypeDE_CODE).format(ie.Values[0].Value)   
                } 
                else if(this.cosyCommunicationControllerService.locale == LocaleTypes.LocaleTypeEN_CODE){  
                  result = new Intl.NumberFormat(LocaleTypes.LocaleTypeEN_CODE).format(ie.Values[0].Value)
                }
              }
          } 
          else if(ie.Attributes.DisplayFormat != null){

            let allowedDecimalPlaces = parseInt(ie.Attributes.DisplayFormat);
            if(this.cosyCommunicationControllerService.locale == LocaleTypes.LocaleTypeDE_CODE){
              result = new Intl.NumberFormat(LocaleTypes.LocaleTypeDE_CODE, { minimumFractionDigits: allowedDecimalPlaces}).format(ie.Values[0].Value)   
            } 
            else if(this.cosyCommunicationControllerService.locale == LocaleTypes.LocaleTypeEN_CODE){  
              result = new Intl.NumberFormat(LocaleTypes.LocaleTypeEN_CODE, { minimumFractionDigits: allowedDecimalPlaces}).format(ie.Values[0].Value)
            }
          }
          ie.Values[0].Value = result;
      }
    }
    return ie;
  }

  sendValueOnLocale(value: any, ie: InterfaceElement){
    if(ie.CosyDataTypeID == InterfaceElementDataTypes.DoubleDT 
      || ie.CosyDataTypeID  == InterfaceElementDataTypes.DecimalDT
      || ie.CosyDataTypeID  == InterfaceElementDataTypes.FloatDT
      || ie.CosyDataTypeID == InterfaceElementDataTypes.IntegerDT
      || ie.CosyDataTypeID == InterfaceElementDataTypes.LongDT
      || ie.CosyDataTypeID  == InterfaceElementDataTypes.ShortDT){
        
        if(this.cosyCommunicationControllerService.locale == LocaleTypes.LocaleTypeDE_CODE){
          /*var parts = new Intl.NumberFormat('de').formatToParts(1111.1);
          var group = parts.find(part => part.type === 'group').value;
          var decimal = parts.find(part => part.type === 'decimal').value;
          var reversedVal = value.replace(new RegExp('\\' + group, 'g'), '');
          reversedVal = reversedVal.replace(new RegExp('\\' + decimal, 'g'), '.');
          value = Number.isNaN(reversedVal)?0:+reversedVal;*/
          value = this.convertNumbersToENGLocale(value);
          
        }
    }    
    return value;
  }

  convertNumbersToENGLocale(value: any){
    var parts = new Intl.NumberFormat('de').formatToParts(1111.1);
    var group = parts.find(part => part.type === 'group').value;
    var decimal = parts.find(part => part.type === 'decimal').value;
    var reversedVal = value.replace(new RegExp('\\' + group, 'g'), '');
    reversedVal = reversedVal.replace(new RegExp('\\' + decimal, 'g'), '.');
    value = Number.isNaN(reversedVal)?0:+reversedVal;
    return value;
  }

  updateDateFormat(displayFormat, dateStringFormat){
    let dateFormatDisplay;
    let dateTimeBreaker = dateStringFormat.split(' ');
   
    if(displayFormat!= null){
      dateFormatDisplay = moment(new Date(dateTimeBreaker[0])).format(displayFormat);
    } else {
      dateFormatDisplay = dateStringFormat
    }
    return dateFormatDisplay;
  }

  getFilteredRows(rowItems: RowItem[], headers: HeaderItem[]) {
    let filteredCols: ColItem[] = [];
    let filteredRows: RowItem[] = [];
    for (let r of rowItems) {
      let rowItem: RowItem = new RowItem();
      rowItem.DisplayName = r.DisplayName;
      rowItem.ID = r.ID;
      filteredCols = [];
      for (let h of headers) {
        for (let c of r.ColItems) {
          if (c.Name == h.Name && h.Attributes.Visible == true) {
            c.Type = h.CosyDataTypeDID;
            if(c.Type == InterfaceElementDataTypes.DoubleDT || c.Type == InterfaceElementDataTypes.FloatDT ||
              c.Type == InterfaceElementDataTypes.IntegerDT || c.Type == InterfaceElementDataTypes.LongDT ||
              c.Type == InterfaceElementDataTypes.ShortDT){
                c.class = "text-sm-right"
              }
            else {
              c.class = "text-sm-left"
            }
          
            c = this.modifyPerHeaderDataType(c, h.CosyDataTypeDID); 
            
            filteredCols.push(c);
          }
        }
      }
      rowItem.ColItems = filteredCols;
      filteredRows.push(rowItem);
    }
    return filteredRows;
  }

  getFilteredRowsPerFilterCriteria(ie: InterfaceElement, filter: IEFilter) {
    let filteredRows: RowItem[] = [];
    let headerItem: HeaderItem;
    let cIndex: number = -1;
    let counter = 0;

    if (ie.EntityList.RowItems.length > 0) {
      cIndex = ie.EntityList.RowItems[0].ColItems.map(function(d) {
        return d['Name'];
      }).indexOf(filter.ColName);
    }

    headerItem = this.getHeaderProperties(filter.ColName, ie);
    for (let row of ie.EntityList.RowItems) {
      for (let col of row.ColItems) {
        if (col.Name == filter.ColName && filter.ColValue !== 'ANY') {
          if (typeof col.Value == 'string') {
            col.Value = col.Value.toLowerCase();
          }
          if (typeof filter.ColValue == 'string') {
            filter.ColValue = filter.ColValue.toLowerCase();
          }

          if (filter.Condition == 'EQ') {
            if (col.Value == filter.ColValue) {
              filteredRows.push(row);
            }
          } else if (filter.Condition == 'GTE') {
            if (filter.RetrieveCategory == 'EVEN') {
              if (col.Value == filter.ColValue || (col.Value > filter.ColValue && col.Value % 2 == 0)) {
                filteredRows.push(row);
              }
            } else if (filter.RetrieveCategory == 'ODD') {
              if (col.Value == filter.ColValue || (col.Value > filter.ColValue && col.Value % 2 == 1)) {
                filteredRows.push(row);
              }
            } else {
              if (col.Value >= filter.ColValue) {
                filteredRows.push(row);
              }
            }
          } else if (filter.Condition == 'LTE') {
            if (filter.RetrieveCategory == 'EVEN') {
              if (col.Value == filter.ColValue || (col.Value < filter.ColValue && col.Value % 2 == 0)) {
                filteredRows.push(row);
              }
            } else if (filter.RetrieveCategory == 'ODD') {
              if (col.Value == filter.ColValue || (col.Value < filter.ColValue && col.Value % 2 == 1)) {
                filteredRows.push(row);
              }
            } else {
              if (col.Value <= filter.ColValue) {
                filteredRows.push(row);
              }
            }
          } else if (filter.Condition == 'GT') {
            if (filter.RetrieveCategory == 'EVEN') {
              if (col.Value > filter.ColValue && col.Value % 2 == 0) {
                filteredRows.push(row);
              }
            } else if (filter.RetrieveCategory == 'ODD') {
              if (col.Value > filter.ColValue && col.Value % 2 == 1) {
                filteredRows.push(row);
              }
            } else {
              if (col.Value > filter.ColValue) {
                filteredRows.push(row);
              }
            }
          } else if (filter.Condition == 'LT') {
            if (filter.RetrieveCategory == 'EVEN') {
              if (col.Value < filter.ColValue && col.Value % 2 == 0) {
                filteredRows.push(row);
              }
            } else if (filter.RetrieveCategory == 'ODD') {
              if (col.Value < filter.ColValue && col.Value % 2 == 1) {
                filteredRows.push(row);
              }
            } else {
              if (col.Value < filter.ColValue) {
                filteredRows.push(row);
              }
            }
          } else if (filter.Condition == 'NE') {
            if (filter.RetrieveCategory == 'EVEN') {
              if (col.Value !== filter.ColValue && col.Value % 2 == 0) {
                filteredRows.push(row);
              }
            } else if (filter.RetrieveCategory == 'ODD') {
              if (col.Value !== filter.ColValue && col.Value % 2 == 1) {
                filteredRows.push(row);
              }
            } else {
              if (col.Value !== filter.ColValue) {
                filteredRows.push(row);
              }
            }
          }
        } else if (col.Name == filter.ColName && filter.ColValue == 'ANY') {
          if (filter.Condition == 'ANY') {
            if (filter.RetrieveCategory == 'EVEN') {
              if (col.Value % 2 == 0) {
                filteredRows.push(row);
              }
            } else if (filter.RetrieveCategory == 'ODD') {
              if (col.Value % 2 == 1) {
                filteredRows.push(row);
              }
            } else {
              filteredRows.push(row);
            }
          }
        }
      }
    }

    if (filteredRows.length == 0 && filter.Name != null && filter.ColName == null && filter.ColValue == null) {
      filteredRows = ie.EntityList.RowItems;
    }

    if (filter.ColOrder == 'ASC') {
      if (headerItem != null && headerItem.CosyDataTypeDID == InterfaceElementDataTypes.IntegerDT) {
        filteredRows.sort((a, b) => a.ColItems[cIndex].Value - b.ColItems[cIndex].Value);
      } else if (headerItem != null && headerItem.CosyDataTypeDID == InterfaceElementDataTypes.StringDT) {
        filteredRows.sort((a, b) => 0 - (b.ColItems[cIndex].Value > a.ColItems[cIndex].Value ? 1 : -1));
      }
    } else if (filter.ColOrder == 'DESC') {
      if (headerItem != null && headerItem.CosyDataTypeDID == InterfaceElementDataTypes.IntegerDT) {
        filteredRows.sort((a, b) => b.ColItems[cIndex].Value - a.ColItems[cIndex].Value);
      } else if (headerItem != null && headerItem.CosyDataTypeDID == InterfaceElementDataTypes.StringDT) {
        filteredRows.sort((a, b) => 0 - (a.ColItems[cIndex].Value > b.ColItems[cIndex].Value ? 1 : -1));
      }
    }

    if (filter.RetrieveLimit !== 'ANY') {
      filteredRows = filteredRows.slice(0, filter.RetrieveLimit);
    }
    return filteredRows;
  }

  getHeaderProperties(headerName: string, ie: InterfaceElement) {
    let headerItem: HeaderItem = null;
    for (let header of ie.EntityList.HeaderItems) {
      if (header.Name == headerName) {
        headerItem = header;
      }
    }
    return headerItem;
  }

  generateInlineUAID(ieType: string, uatype:string) {
    let ua: IEUserAction = new IEUserAction();

    if (ieType == InterfaceElementTypes.InputDate || ieType == InterfaceElementTypes.InputText || ieType == InterfaceElementTypes.InputNumber || ieType == InterfaceElementTypes.InputBoolean) {
      ua.ID = '014b2752-14e6-4b3c-9995-2bc6f7212070';
      ua.TemplateID = '2c72c521-6e62-46da-984c-e96ac6fa93e6';
      ua.TypeDID = 'eb5a4a81-3d8d-4ef0-be61-d881fe396136';
      ua.Name = 'UAStdGetSelected';
      ua.UserActionID = '31895aca-55fa-4b61-b4a0-92c8074fb628';
      ua.ActionProcessOnServer = false;
    } else if (ieType == InterfaceElementTypes.EntityList) {
      if (uatype == 'OnInitUAID'){
        ua.ID = 'aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee';
        ua.TypeDID = '30ac6ae0-9d65-4e39-b025-a06a848286c6';
        ua.Name = 'OnInitUAID';
        ua.UserActionID = 'aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee';
        ua.ActionProcessOnServer = false;
      }
      else{
        ua.ID = '0fb49d62-bc56-4cc4-b9e9-8bcd79e7addb';
        ua.TemplateID = 'e810dec2-b01f-448c-a580-fcb63a907c90';
        ua.TypeDID = '30ac6ae0-9d65-4e39-b025-a06a848286c6';
        ua.Name = 'UAStdOnSelect';
        ua.UserActionID = 'c618936b-d76a-4f52-8574-86aa7d6f6de8';
        ua.ActionProcessOnServer = false;
      }
    } else if (ieType == InterfaceElementTypes.InputPicklist) {
      ua.ID = '51dc60dd-b5a4-43bb-a6e5-4d887a31a9e9';
      ua.TemplateID = '7b3973d9-4cd0-46ed-a419-3e5ff5a3512d';
      ua.TypeDID = 'eb5a4a81-3d8d-4ef0-be61-d881fe396136';
      ua.Name = 'UAStdGetSelected';
      ua.UserActionID = '31895aca-55fa-4b61-b4a0-92c8074fb629';
      ua.ActionProcessOnServer = false;
    }
    return ua;
  }

  updateCustomizedHeaders(asdHeader: Header, vas: ViewArea[]) {
    asdHeader.Title = this.updateCustomizedViewAreas(asdHeader.Title, vas);
    return asdHeader;
  }

  upDateCustomizedInterfaceElements(data, ieFormats: { key: any; value: any }[], ieFrom: InterfaceElement) {
    let result;

    for (let i of ieFormats) {
      let ID = i.value.substring(i.value.indexOf(':') + 1, i.value.indexOf('.'));
      let property = i.value.substring(i.value.indexOf('.') + 1, i.value.length - 2);

      if (ieFrom[i.key] == ID) {
        if (property.indexOf('.') > -1) {
          let finalValue;
          var proplist = property.split(':');

          if (proplist.length == 2) {
            let propkey = proplist[0].substring(0, proplist[0].indexOf('.'));
            let propProperty = proplist[0].substring(proplist[0].indexOf('.') + 1, proplist[0].length);
            if (propkey == 'InterfaceElements') {
              for (let i of ieFrom.InterfaceElements) {
                let keyList = proplist[1].split('.');
                if (i[propProperty] == keyList[0]) {
                  finalValue = i[keyList[1]];
                }
              }
            }
          }
          if (proplist.length == 1) {
            var keyList = proplist[0].split('.');
            let v = ieFrom;
            for (var k = 0; k < keyList.length; k++) {
              if (v.hasOwnProperty(keyList[k])) {
                v = v[keyList[k]];
              }
            }
            finalValue = v;
          }
          result = finalValue;
        } else {
          result = ieFrom[property];
        }
      }
      if (result != null && result.length > 0) {
        if (Array.isArray(result) && result[0].hasOwnProperty('Value')) {
          result = result[0]['Value'];  
        }
        else {
          result = '<>';
        }
        data = data.replace(i.value, result);
      }
    }
    return data;
  }

  updateCustomizedViewAreas(customData: string, vas: ViewArea[]) {
    let key, regex, result;
    let needToFormat: string;
    let keyIndexes = [];
    let chIndexes = [];

    let vaFormattedStrings: { key: any; value: any }[] = [];
    let ieFormattedStrings: { key: any; value: any }[] = [];

    let ie: InterfaceElement = new InterfaceElement();

    if (customData != null) {
      regex = /%%/gi;
      while ((result = regex.exec(customData))) {
        chIndexes.push(result.index);
      }

      if (customData.indexOf('%%VA-') > -1) {
        keyIndexes = [];
        key = 'ViewArea' + customData.substring(customData.indexOf('VA-') + 3, customData.indexOf(':'));
        regex = /%%VA/gi;
        while ((result = regex.exec(customData))) {
          keyIndexes.push(result.index);
        }

        for (let i of keyIndexes) {
          let nextIndex;
          for (let c of chIndexes) {
            if (c > i) {
              nextIndex = c;
              break;
            }
          }
          needToFormat = customData.substring(i, nextIndex + 2);
          vaFormattedStrings.push({ key: key, value: needToFormat });
        }
      }
      if (customData.indexOf('%%IE-') > -1) {
        var colonIndex = -1;

        for (var i = 0; i < customData.length; i++) {
          if (customData[i] === ':' && i > customData.indexOf('IE-')) {
            colonIndex = i;
            break;
          }
        }

        keyIndexes = [];
        key = 'InterfaceElement' + customData.substring(customData.indexOf('IE-') + 3, colonIndex);

        if (!ie.hasOwnProperty(key)) {
          key = customData.substring(customData.indexOf('IE-') + 3, colonIndex);
        }

        regex = /%%IE/gi;
        while ((result = regex.exec(customData))) {
          keyIndexes.push(result.index);
        }

        for (let i of keyIndexes) {
          let nextIndex;
          for (let c of chIndexes) {
            if (c > i) {
              nextIndex = c;
              break;
            }
          }
          needToFormat = customData.substring(i, nextIndex + 2);
          ieFormattedStrings.push({ key: key, value: needToFormat });
        }
      }
      for (let va of vas) {
        if (vaFormattedStrings.length > 0) {
          for (let v of vaFormattedStrings) {
            let ID = v.value.substring(v.value.indexOf(':') + 1, v.value.indexOf('.'));
            let property = v.value.substring(v.value.indexOf('.') + 1, v.value.length - 2);
            if (va[v.key] == ID) {
              customData = customData.replace(v.value, va[property]);
            }
          }
        }
        if (ieFormattedStrings.length > 0) {
          for (let vie of va.InterfaceElements) {
            customData = this.upDateCustomizedInterfaceElements(customData, ieFormattedStrings, vie);
            if (vie.InterfaceElements != null) {
              for (let viee of vie.InterfaceElements) {              
                customData = this.upDateCustomizedInterfaceElements(customData, ieFormattedStrings, viee);
              }
            }
          }
        }
      }
    }
    return customData;
  }

  updateCustomizedFormats(ies: InterfaceElement[], vas: ViewArea[]) {
    let formatedDisplay;
    for (let ie of ies) {
      if (ie.TypeDID == InterfaceElementTypes.Label) {
       
          if (ie.Label.DisplayName.indexOf('%%') > -1) {
       
          let displayName = this.updateCustomizedViewAreas(ie.Label.DisplayName, vas);
          ie.Label.DisplayName =   displayName;       
        }
      }
    }
    return ies;
  }
}
